import react, { useRef, useEffect, useState, Fragment } from "react";
import { Box, Paper } from "@mui/material";
import clss from "./Mfmsg.module.css";
import ReactDOM from "react-dom";
import { QRCodeSVG } from "qrcode.react";
import { Close } from "@mui/icons-material";

<QRCodeSVG value="https://reactjs.org/" />;
document.getElementById("mountNode");

const MFqrcode = (props) => {
  const code = props.code;
  const resourceLabel = (props.resourceLabel || "자원").toString().trim() || "자원";

  const viewHandler = () => {
    props.viewqr();
  };

  return (
    <Fragment>
      <Box className={clss.background}>
        <div className={clss.maincss}>
          <div className={clss.titlebar}>
            <span style={{ fontSize: "1.5rem", fontWeight: "bold", color: "white", alignContent: "center" }}>
              {resourceLabel} 인수인계
            </span>
            <Close onClick={viewHandler} />
          </div>
          <QRCodeSVG
            value={code}
            size={"100%"}
            bgColor={"#ffffff"}
            fgColor={"#000000"}
            level={"Q"}
            includeMargin={true}
            // imageSettings={{
            //   src: "https://static.zpao.com/favicon.png",
            //   x: undefined,
            //   y: undefined,
            //   height: 24,
            //   width: 24,
            //   excavate: true,
            // }}
          />
        </div>
      </Box>
    </Fragment>
  );
};

export default MFqrcode;
